import { SvgIcon, Tooltip } from '@mui/material';
import React, { Dispatch, SetStateAction, useContext } from 'react';
import { UserContext } from '../../../common/auth/UserContext';
import I18n from '../../../common/i18n/I18n';
import { Icons } from '../../../common/icons/Icons';
import useShowResumeIconByApp from '../../../common/list/dataListComponents/useShowResumeIconByApp';
import { useStyling } from '../../../common/Theme';
import download from '../../../common/utils/download';
import UploadResume from './UploadResume';

export const ResumeAddIcon = ({ onClick }) => {
    const { theme } = useStyling();
    return (
        <Tooltip title={<I18n token="upload.resume.title" />}>
            <SvgIcon
                component={Icons.ResumeAdd}
                sx={{ cursor: 'pointer', color: theme.palette.action.active }}
                onClick={onClick}
            />
        </Tooltip>
    );
};

export const ResumeIcon = ({ selectedFile, entityReference }) => {
    const { activeOrganizationAccount } = useContext(UserContext);
    const { theme } = useStyling();
    return (
        <SvgIcon
            component={Icons.ResumeIcon}
            sx={{ cursor: 'pointer', color: theme.palette.action.active }}
            onClick={(e) => {
                e.stopPropagation();
                download(entityReference?.id, entityReference?.label, activeOrganizationAccount, '_blank');
            }}
        />
    );
};
type PersonHeaderResumeProps = {
    hideResumeIcon?: boolean;
    personData: any;
    setPersonData: Dispatch<SetStateAction<any>>;
    hideUploadResumeIcon?: boolean;
};

export default function PersonHeaderResume({
    hideResumeIcon,
    hideUploadResumeIcon = false,
    personData,
    setPersonData
}: PersonHeaderResumeProps) {
    const showResumeIconByApp = useShowResumeIconByApp(personData);

    if (!setPersonData) {
        return null;
    }

    return (
        !hideResumeIcon &&
        showResumeIconByApp && (
            <UploadResume
                UploadIconComponent={ResumeAddIcon}
                FileRenderer={ResumeIcon}
                state={personData}
                setState={setPersonData}
                hideUploadResumeIcon={hideUploadResumeIcon}
            />
        )
    );
}
